export const GAME_WIDTH = 800;
export const GAME_HEIGHT = 600;
export const GAME_BACKGROUND_COLOR = 0xd3d3d3;
